import { UPDATE_IS_LOADING_DASHBOARD } from "../types";

export const updateLoadingDashboard = (data: boolean) => ({
  type: UPDATE_IS_LOADING_DASHBOARD,
  payload: data
})